import { Component, OnInit } from '@angular/core';

import * as _ from 'underscore';
import { ProductService } from '../../shared/services/product.service';
import { ActivatedRoute } from '@angular/router';
import { PartDetails } from './partdetails/partdetails.model';
import { PartService } from '../../shared/services/part.service';

@Component({
    selector: 'app-part',
    templateUrl: 'part.component.html'
})

export class PartComponent implements OnInit {
    partDetails: PartDetails;
    partGroupId: number;
    isDataLoaded = false;

    constructor(private _partService: PartService, private _route: ActivatedRoute) {

    }

    getPartDetails() {
        this._partService.getPartDetailsByPartGroupId(this.partGroupId).subscribe(res => {
            this.partDetails = res;
            this.isDataLoaded = true;
        });
    }
    ngOnInit() {
        this._route.params.subscribe(param => {
            this.partGroupId = +param['pgid'];
            this.getPartDetails();
        });
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/part/part.component.ts